/**
 * Session replay privacy helpers.
 *
 * Input masking is global (`mask_input_options.text` in `NewRelicScript`) — you
 * cannot asterisk-mask a single input from here. We tried per-field attributes
 * first; `data-nr-block` left inputs blank in replay, which looked like a bug.
 *
 * - `SERVICEABILITY_ADDRESS_NR_MASK_PROPS` — mask static address text in buttons/labels
 * - `SESSION_REPLAY_NR_UNMASK_PROPS` — opt a non-sensitive input out of global masking
 *
 * @see docs/new-relic.md
 */

/** Masks address text in non-input elements (suggestions, labels, banners). */
export const SERVICEABILITY_ADDRESS_NR_MASK_PROPS = {
  "data-nr-mask": true,
} as const;

/** Opts a non-sensitive text input out of global masking. Not for PII fields. */
export const SESSION_REPLAY_NR_UNMASK_PROPS = {
  "data-nr-unmask": true,
} as const;
